import React, { useState, useEffect } from "react";
import { Button, Card, Badge } from "react-bootstrap";
import { BsArrowUpRight } from "react-icons/bs";
import { FaSearch } from "react-icons/fa";
import Select from "react-select";
import BarChart from "../chart/BarChart";
import NewPOsModal from "../modal/NewPOsModal";
import IndividualOrderDetailsModal from "../modal/IndividualOrderDetailsModal";
import AddProductionPlanModal from '../modal/AddProductionPlanModal';
import ModificationProductionModal from "../modal/ModificationProductionModal";
import POStatusModal from "../modal/POStatusModal";
import IndividualProductionDetailsModal from "../modal/IndividualProductionDetailsModal";
import { FaFileAlt, FaExclamationTriangle } from "react-icons/fa";
import config from "../../config/config";
import axios from "axios";
import Loader from "../loader/Loader";
import { getAuthToken } from "../../utils/token";
import MonthlyProductionBoardModal from '../modal/MonthlyProductionBoardModal';
import MaterialIssueRequstModal from "../modal/MaterialIssueRequstModal";
const ProductPlanning = () => {
  const [monthlyProductionBoard, setMonthlyProductionBoard] = useState(false)
  const [addProductionPlan, setAddProductionPlan] = useState(false);
  const [modificationProduction, setModificationProduction] = useState(false);
  const [newPo, setNewPo] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [pOStatus, setPOStatus] = useState(false);
  const [individualProductionDetails, setIndividualProductionDetails] =
    useState(false);
  const [upcomingOrders, setUpcomingOrders] = useState([]);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [materialIssue, setMaterialIssue] = useState(false)
  const [planing, setPlaning] = useState([])
  const [filteredPOs, setFilteredPOs] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [productionPlanId, setProductionPlanId] = useState(null)
  const [getProductionplan, setGetProductionplan] = useState([]);
  const [individualId, setIndividualId] = useState(null)
  const [productOptions, setProductOptions] = useState([]);
  const [dailyproductionoverview, setDailyproductionoverview] = useState({
    labels: [],
    datasets: [
      {
        label: "Planned",
        data: [],
        backgroundColor: "#0a28a3",
      },
      {
        label: "Actual",
        data: [],
        backgroundColor: "#4ea0f0",
      },
    ],
  });

  useEffect(() => {
    fetchOrders();
    fetchPlaningactions();
    fetchProductionplan();
    DailyProductionoverview();
    fetchProductList()
  }, []);

  const fetchOrders = async () => {
    const token = getAuthToken();
    if (!token) return;

    setLoading(true);
    try {
      const response = await axios.get(
        `${config.API}/manager/upcomingorders`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.success === true) {
        setUpcomingOrders(response.data.orders);
      } else {
        setUpcomingOrders([]);
      }
    } catch (err) {
      console.error("Error fetching orders:", err);
      setUpcomingOrders([]);
    } finally {
      setLoading(false);
    }
  };
  const fetchPlaningactions = async () => {
    const token = getAuthToken();
    if (!token) return;
    setLoading(true);
    try {
      const response = await axios.get(`${config.API}/manager/planningactions`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response?.data?.success) {
        setPlaning(response?.data);
        setFilteredPOs(response?.data?.purchaseOrdersCount || []);
      } else {
        setPlaning([]);
        setFilteredPOs([]);
      }
    } catch (err) {
      console.error("Error fetching orders:", err.message);
      setPlaning([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
    if (!value) {
      setFilteredPOs(planing?.purchaseOrdersCount || []);
      return;
    }
    const filtered = planing?.purchaseOrdersCount.filter((poNumber) =>
      poNumber?.po_number?.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredPOs(filtered);
  };
  const fetchProductionplan = async () => {
    const token = getAuthToken();
    if (!token) return;
    setLoading(true);
    try {
      const response = await axios.get(`${config.API}/manager/getproductionplan`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response?.data?.success) {
        setGetProductionplan(response?.data?.plans || []);
      } else {
        setGetProductionplan([]);
      }
    } catch (err) {
      console.error("Error fetchProductionplan:", err.message);
      setGetProductionplan([]);
    } finally {
      setLoading(false);
    }
  };

  const DailyProductionoverview = async (productId = null) => {
    const token = getAuthToken();
    if (!token) return;
    setLoading(true);
    try {
      const response = await axios.post(
        `${config.API}/manager/dailyproductionoverview`,
        {
          product_id: productId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const result = response?.data?.production_summary || [];
      const dailyProductionDate = response?.data?.date || "00/00/0000";
      if (result.length > 0) {
        setDailyproductionoverview({
          labels: [dailyProductionDate],
          datasets: [
            {
              label: "Planned",
              data: result.map((item) => Number(item?.planned)),
              backgroundColor: "#0a28a3",
            },
            {
              label: "Actual",
              data: result.map((item) =>
                Number(item?.total_units_produced)
              ),
              backgroundColor: "#4ea0f0",
            },
          ],
        });
      } else {
        setDailyproductionoverview(null);
      }
    } catch (err) {
      console.error("Error DailyProductionoverview:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchProductList = async () => {
    const token = getAuthToken();
    if (!token) return;
    setLoading(true);
    try {
      const response = await axios.get(`${config.API}/product/list`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProductOptions(
        response?.data?.products?.map((plist) => ({
          value: plist.id,
          label: plist.name,
        })) || []
      );
    } catch (err) {
      console.error("Error fetching products:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid p-4">
      <div className="row ">
        <div className="col-md-6 mb-4">
          <div className="shadow-sm card font_family h-50">
            <div className="d-flex justify-content-between p-3">
              <strong className="fs-4 font_family">Production Schedule</strong>
              <Button className="btn btn-dark" size="sm" onClick={() => setMonthlyProductionBoard(true)}>
                View
              </Button>
            </div>
            <Card.Body style={{ maxHeight: '350px', overflowY: 'auto' }}>
              {loading ? (
                <Loader />
              ) : (
                <>
                  {getProductionplan && getProductionplan.length > 0 ? (
                    getProductionplan.map((Productionplan, index) => {
                      const [year, month, day] = Productionplan?.delivery_date.split("-");
                      const deliveryDate = new Date(year, month - 1, day);
                      const formattedDate = deliveryDate.toLocaleDateString("en-GB", {
                        weekday: "long",
                      });

                      const today = new Date();
                      const diffInDays = Math.ceil(
                        (deliveryDate - today) / (1000 * 60 * 60 * 24)
                      );

                      let status = "";
                      let variant = "";

                      if (diffInDays > 7) {
                        status = "On Track";
                        variant = "success";
                      } else if (diffInDays >= 0 && diffInDays <= 7) {
                        status = "At Risk";
                        variant = "warning";
                      } else {
                        status = "Delayed";
                        variant = "danger";
                      }

                      return (
                        <div
                          key={index}
                          className="d-flex justify-content-between align-items-center mb-3"
                        >
                          <div style={{ cursor: "pointer" }}>
                            <strong
                              onClick={() => {
                                setIndividualId(Productionplan?.product_id);
                                setIndividualProductionDetails(true);
                              }}
                            >
                              {Productionplan?.product?.name} <BsArrowUpRight />
                            </strong>
                            <div className="text-muted small">
                              {Productionplan?.total_qty_pending} units by {Productionplan?.month}
                            </div>
                          </div>
                          <Badge
                            bg={`${variant}-subtle`}
                            text={variant}
                            className="px-3 py-2"
                          >
                            {status}
                          </Badge>
                        </div>
                      );
                    })
                  ) : (
                    <div className="text-center text-muted py-4">
                      <strong>No Data Found</strong>
                    </div>
                  )}
                </>
              )}
            </Card.Body>
          </div>
          <div className="shadow-sm card mt-1 h-50">
            <div className="d-flex justify-content-between p-3">
              <strong className="fs-4">In Process Orders</strong>
              <Button
                className="btn btn-dark"
                size="sm"
                onClick={() => {
                  setPOStatus(true);
                }}
              >
                View All
              </Button>
            </div>
            <Card.Body style={{ maxHeight: '480px', overflowY: 'auto' }}>
              {loading ? (
                <Loader />
              ) : (
                <>
                  {upcomingOrders && upcomingOrders.length > 0 ? (
                    upcomingOrders.map((order, index) => (
                      <div
                        key={index}
                        className="d-flex flex-column flex-md-row justify-content-between align-items-start gap-2 border-start border-4 border-danger bg-danger-subtle p-3 mb-3 rounded"
                      >
                        <div className="flex-grow-1">
                          <strong>PO ID : {order?.po_number}</strong>
                          <div className="small">{order?.consignee}</div>
                        </div>
                        <div>
                          <Button
                            variant="light"
                            className="bg-white text-dark px-3 py-1"
                            size="sm"
                            onClick={() => {
                              setSelectedOrderId(order?.id);
                              setShowModal(true);
                            }}
                          >
                            View PO Details
                          </Button>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center text-muted py-3">
                      No data found
                    </div>
                  )}
                </>

              )}
            </Card.Body>
          </div>
        </div>
        <div className="col-md-6 mb-4 card font_family">
          {
            loading ? (
              <Loader />
            ) : (
              <>
                <strong className="p-2 fs-4">Planning Actions</strong>

                <div className="input-group shadow-sm rounded-pill overflow-hidden">
                  <input
                    type="text"
                    className="form-control  py-2 px-3"
                    placeholder="Search PO Number..."
                    aria-label="Search term"
                    value={searchTerm}
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                  <button className="btn btn-primary px-4 search-btn" type="button">
                    <FaSearch />
                  </button>
                </div>
                <div className="shadow-sm mt-1">
                  {loading ? (
                    <Loader />
                  ) : (
                    <div className="shadow-sm mt-3 overflow-auto" style={{ maxHeight: "350px" }}>
                      {filteredPOs && filteredPOs.length > 0 ? (
                        filteredPOs.map((purchaseOrders, index) => (
                          <div
                            key={index}
                            className="mb-3 border-primary bg-primary bg-opacity-10 border-start border-4 rounded p-1"
                          >
                            <Card.Body>
                              <h6
                                className="text-primary fw-bold"
                                style={{ cursor: "pointer" }}
                              >
                                <FaFileAlt /> New Product Requirement Received
                              </h6>

                              <p>
                                New order for {purchaseOrders?.product_name} ({purchaseOrders?.quantity} units)
                                due on{" "}
                                {new Date(purchaseOrders?.delivery_date).toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                })}<br />
                                <span className="fw-bold">PO Number: </span>{purchaseOrders?.po_number}
                              </p>
                              <Button
                                variant="dark"
                                size="sm"
                                className="me-2 mb-1"
                                onClick={() => {
                                  setAddProductionPlan(true);
                                  setProductionPlanId(purchaseOrders?.id);
                                }}
                              >
                                Schedule Production
                                {/* Approve Order */}
                              </Button>
                            </Card.Body>
                          </div>
                        ))
                      ) : (
                        <div className="p-3 text-center text-muted">
                          No purchase orders found
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div className="shadow-sm mt-1">
                  {
                    loading ? (
                      <Loader />
                    ) : (
                      <div
                        className="shadow-sm mt-3 overflow-auto"
                        style={{ maxHeight: "350px" }}
                      >
                        {planing?.behindScheduleCount && planing.behindScheduleCount.length > 0 ? (
                          planing.behindScheduleCount.map((item, index) => (
                            <div
                              key={index}
                              className="mb-3 border-danger bg-danger bg-opacity-10 border-start border-4 rounded p-1"
                            >
                              <Card.Body>
                                <h6
                                  className="text-danger fw-bold"
                                  style={{ cursor: "pointer" }}
                                >
                                  <FaExclamationTriangle /> {item?.material_name} Behind Schedule
                                </h6>
                                <p>
                                  Currently ({item?.total_qty_pending} units) behind target. Material delay is causing production slowdown.
                                </p>
                                <Button
                                  variant="light"
                                  size="sm"
                                  className="me-2 mb-1"
                                  onClick={() => setModificationProduction(true)}
                                >
                                  Adjust Timeline
                                </Button>
                                <Button
                                  variant="dark"
                                  size="sm"
                                  className="me-2 mb-1"
                                  onClick={() => setMaterialIssue(true)}
                                >
                                  Expedite Materials
                                </Button>
                              </Card.Body>
                            </div>
                          ))
                        ) : (
                          <div className="p-3 text-center text-muted">
                            No behind-schedule orders found
                          </div>
                        )}
                      </div>
                    )
                  }
                </div>

                <button className="btn btn-dark mt-3 mb-3" onClick={() => setMonthlyProductionBoard(true)}>
                  View Full Planning Board
                </button>
              </>
            )
          }
        </div>
      </div>
      <div className="row mt-2">
        <div className="p-1">
          <div className="col-12 col-md-12 p-3 border rounded bg-light w-100 h-100">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <strong className="fs-4">Daily Production Overview</strong>

              <div style={{ width: "320px" }}>
                <Select
                  options={productOptions}
                  placeholder={"Select Product"}
                  isClearable
                  onChange={(selected) => {
                    if (selected) {
                      DailyProductionoverview(selected.value);
                    } else {
                      DailyProductionoverview(null);
                    }
                  }}
                />
              </div>
            </div>

            <div className="p-4">
              <BarChart chartData={dailyproductionoverview} />
            </div>
          </div>
        </div>
      </div>
      <NewPOsModal show={newPo} handleClose={() => setNewPo(false)} />
      {/* IndividualOrderDetailsModal */}
      <IndividualOrderDetailsModal
        show={showModal}
        orderId={selectedOrderId}
        handleClose={() => setShowModal(false)}
      />
      {/* POStatusModal */}
      <POStatusModal show={pOStatus} handleClose={() => setPOStatus(false)} />
      {/* IndividualProductionDetailsModal */}
      <IndividualProductionDetailsModal
        show={individualProductionDetails}
        individualId={individualId}
        handleClose={() => setIndividualProductionDetails(false)}
      />
      {/* MonthlyProductionBoardModal */}
      <MonthlyProductionBoardModal
        show={monthlyProductionBoard}
        handleClose={() => setMonthlyProductionBoard(false)}
      />
      <AddProductionPlanModal
        planId={productionPlanId}
        show={addProductionPlan}
        handleClose={() => setAddProductionPlan(false)}
      />
      {/* Nested modal */}
      <ModificationProductionModal
        show={modificationProduction}
        handleClose={() => setModificationProduction(false)}
      />
      {/* MaterialIssueRequstModal */}
      <MaterialIssueRequstModal
        show={materialIssue}
        handleClose={() => setMaterialIssue(false)}
      />
    </div>
  );
};

export default ProductPlanning;
